import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import { createApiDateFormat, getDefaultTimezone, } from 'helpers/date-time';

const chatsSlice = createSlice({
  name: 'chats',
  initialState: {
    data: [],
    loading: true,
    receiveNewChatMessage: false,
    lastUpdatedChatSessionId: 0,
    apiCalled: false,
  },
  reducers: {
    hydrateChatFeed: (state, action) => {
      state.data = action.payload.data;
      state.total_pages = action.payload.total_pages;
      state.loading = false;
      state.apiCalled = true;
    },
    requestChatFeed: (state) => {
      state.loading = true;
      state.apiCalled = false;
    },
    appendChatFeed: (state, action) => {
      const idx = state.data.findIndex((chatSession) => chatSession.id === action.payload.id);

      if (idx >= 0) {
        // Replace the existing session
        state.data[idx] = action.payload;
      } else {
        // Append new session
        const newData = [...state.data, action.payload];
        state.data = newData;
      }

      state.loading = false;
    },
    removeChatFeed: (state, action) => {
      const idx = state.data.findIndex((channel) => channel.id === action.payload.id);
      if (idx >= 0) {
        const newData = [...state.data];
        newData.splice(idx, 1);
        state.data = newData;
      }
    },
    updateChatFeedLastContent: (state, action) => {
      const idx = state.data.findIndex((chatSession) => chatSession.id === action.payload.chat_session_id);
      if (idx >= 0) {
        const newData = [...state.data];
        newData[idx].latest_message = action.payload.content;
        if (action.payload.updated_at !== undefined) {
          newData[idx].updated_at = action.payload.updated_at;
        }
        state.data = newData;
        state.lastUpdatedChatSessionId = action.payload.chat_session_id;
      }
    },
    NotifyNewChatMessage: (state, action) => {
      const idx = state.data.findIndex((channel) => channel.id === action.payload);
      if (idx >= 0) {
        const newData = [...state.data];
        newData[idx].receiveNewChatMessage = true;
        state.data = newData;
      }
    },
    ResetNotifyNewChatMessage: (state, action) => {
      const idx = state.data.findIndex((channel) => channel.id === action.payload);
      if (idx >= 0) {
        const newData = [...state.data];
        newData[idx].receiveNewChatMessage = false;
        state.data = newData;
      }
    },
    updateChatFeedInfo: (state, action) => {
      const idx = state.data.findIndex((channel) => channel.id === action.payload.channel_id);
      if (idx >= 0) {
        const newData = [...state.data];
        newData[idx].channel_name = action.payload.channel_name;
        newData[idx].description = action.payload.description;
        state.data = newData;
      }
    },
    resetChatFeed: (state, action) => {
      state.data = [];
    },
  },
});

export default chatsSlice;
